import React, { useState, useRef } from "react";
import { Modal, Input, Button } from "antd";
import Draggable from "react-draggable";
import { TicketViewModel } from "../../../../store/data/models/ticket-view-model";
import { useAddUpdateMutation } from "../../../../store/services/api/ticket-api";

interface UpdateTicketModalProps {
  ticket: TicketViewModel;
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

export default function UpdateTicketModal({
  ticket,
  open,
  onClose,
  onSuccess,
}: UpdateTicketModalProps) {
  const [updateText, setUpdateText] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [addUpdate, { isLoading }] = useAddUpdateMutation();

  // Draggable modal setup
  const [disabled, setDisabled] = useState(true);
  const draggleRef = useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = useState(false);

  const clearError = () => setError(null);

  const handleSave = async () => {
    if (!updateText.trim()) {
      setError("Update can't be empty");
      return;
    }

    const result = (await addUpdate({
      text: updateText,
      ticketId: ticket.id,
    })) as any;

    if (result.error) {
      setError("Failed to add update. Please try again.");
      return;
    }

    setUpdateText("");
    onClose();
    onSuccess?.();
  };

  return (
    <Modal
      open={open}
      title={
        <div
          style={{ cursor: "move", width: "100%" }}
          onMouseOver={() => disabled && setDisabled(false)}
          onMouseOut={() => setDisabled(true)}
        >
          Add Ticket Update
        </div>
      }
      onCancel={onClose}
      destroyOnClose
      centered={false}
      width={600}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="save"
          type="primary"
          loading={isLoading}
          onClick={handleSave}
        >
          Save
        </Button>,
      ]}
      modalRender={(modal) => (
        <Draggable
          disabled={disabled}
          nodeRef={draggleRef}
          onStart={() => setIsDragging(true)}
          onStop={() => setIsDragging(false)}
        >
          <div
            ref={draggleRef}
            style={{
              willChange: "transform",
              pointerEvents: isDragging ? "none" : "auto",
            }}
          >
            {modal}
          </div>
        </Draggable>
      )}
    >
      <div style={{ minWidth: 500 }}>
        <Input.TextArea
          rows={10}
          placeholder="Enter your update here..."
          value={updateText}
          onChange={(e) => {
            setUpdateText(e.target.value);
            clearError();
          }}
        />
        {error && (
          <div style={{ color: "red", marginTop: 8, textAlign: "center" }}>
            {error}
          </div>
        )}
      </div>
    </Modal>
  );
}
